import React from 'react';

import { Link } from '../../Link';
import * as S from '../styles';
import { useAnalyticsEvents } from '../../../hooks/useAnalyticsEvent';

import iconDocs from '../../../images/Header/icon-docs.svg';
import iconIntegration from '../../../images/Header/icon-integration.svg';
import iconBillet from '../../../images/Header/icon-billet.svg';
import iconDoubt from '../../../images/Header/icon-doubt.svg';

export const SiteMenu = () => {
  const { sendEvent } = useAnalyticsEvents();

  const sendMenuEvent = (ctaReference, description, sectionReference = 'Header') => {
    sendEvent({
      label: '',
      entity: 'page',
      name: 'cta pagarme',
      description: description,
      deduplicate: false,
      section_reference: sectionReference,
      cta_reference: ctaReference,
    });
  };

  const handleHeaderEvent = (label) => {
    sendMenuEvent(label, `Evento disparado quando o usuário clicar no link "${label}" no cabeçalho da home`);
  };

  const subMenusHelp = [
    {
      label: 'Dúvidas',
      image: iconDoubt,
      subtitle: 'Confira nossa Central de Ajuda',
      path: 'https://pagarme.helpjuice.com/',
    },
    {
      label: 'Boleto DDA',
      image: iconBillet,
      subtitle: 'Consulte seu boleto',
      path: '/boletos',
      asLinkFromGatsby: true,
    },
  ];

  const subMenusDevs = [
    {
      label: 'Guia de integração',
      path:
        'https://docs.pagar.me/page/guias-pagarme?_gl=1*r3p3fd*_gcl_aw*R0NMLjE3MzMxNTkwMzEuQ2p3S0NBaUEwclc2QmhBY0Vpd0FRSDI4SXZ2M1ZsVF96aUQxTTNsd3ZiNVRDclZicGpZV1l2UnBSMkNJMnBHOG5Bc2hXRk1UX0l6S1VCb0NQZmdRQXZEX0J3RQ..*_gcl_au*ODY1NDQ2OTQ3LjE3MzcxMjMwOTkuMjE0NTg0NTg4OC4xNzM3NDA5NjM5LjE3Mzc0MDk2Mzg.*_ga*MTg0MjMyMzAzMS4xNzM3MTIzMDk4*_ga_D3WKQ4C3N8*MTczNzQ3ODQwMS45LjEuMTczNzQ4MjI5OS4zNi4wLjA.',
      image: iconIntegration,
      subtitle: 'Saiba como começar a usar o Pagar.me',
      asLinkFromGatsby: true,
    },
    {
      label: 'Documentação',
      path:
        'https://docs.pagar.me/?_gl=1*1f5bvy4*_gcl_aw*R0NMLjE3MzMxNTkwMzEuQ2p3S0NBaUEwclc2QmhBY0Vpd0FRSDI4SXZ2M1ZsVF96aUQxTTNsd3ZiNVRDclZicGpZV1l2UnBSMkNJMnBHOG5Bc2hXRk1UX0l6S1VCb0NQZmdRQXZEX0J3RQ..*_gcl_au*ODY1NDQ2OTQ3LjE3MzcxMjMwOTkuMjE0NTg0NTg4OC4xNzM3NDA5NjM5LjE3Mzc0MDk2Mzg.*_ga*MTg0MjMyMzAzMS4xNzM3MTIzMDk4*_ga_D3WKQ4C3N8*MTczNzQ3ODQwMS45LjEuMTczNzQ4MjI5OS4zNi4wLjA.',
      image: iconDocs,
      subtitle: 'Referências e bibliotecas da nossa API',
      asLinkFromGatsby: true,
    },
  ];

  const sendSubmenuEvent = ({ cta, subMenu }) => {
    sendEvent({
      label: '',
      entity: 'page',
      name: 'cta pagarme',
      description: `Evento disparado no menu de ${cta} no cabeçalho da home`,
      deduplicate: false,
      section_reference: 'Menu',
      cta_reference: cta,
      section_submenu: subMenu,
    });
  };

  const isActivePage = (path) => {
    if (typeof window !== 'undefined' && window.location) {
      return window?.location.pathname.includes(path) && 'active';
    }

    return '';
  };

  return (
    <S.MenuItems>
      <S.MenuItem className={isActivePage('/produtos')}>
        <Link to="/produtos" onClick={() => handleHeaderEvent('Produtos')} absolute>
          Produtos
        </Link>
      </S.MenuItem>
      <S.MenuItem>
        <Link to="/ofertas" onClick={() => handleHeaderEvent('Ofertas')} absolute>
          Ofertas
        </Link>
      </S.MenuItem>
      <S.MenuItem className={isActivePage('/negocios-que-atendemos')}>
        <Link to="/negocios-que-atendemos" onClick={() => handleHeaderEvent('Negócios que atendemos')} absolute>
          Negócios que atendemos
        </Link>
      </S.MenuItem>
      <S.MenuItem className={isActivePage('/sobre')}>
        <Link style={{ whiteSpace: 'nowrap' }} to="/sobre" onClick={() => handleHeaderEvent('O Pagar.me')} absolute>
          O Pagar.me
        </Link>
      </S.MenuItem>

      <S.MenuItem>
        <div className="dropdown">
          <ul className="dropdown-content">
            {subMenusDevs.map(({ label, image, subtitle, path }) => (
              <li key={path}>
                <Link
                  className="dropdown-item"
                  to={path}
                  onClick={() =>
                    sendSubmenuEvent({
                      cta: 'Desenvolvedores',
                      subMenu: label,
                    })
                  }
                >
                  <img src={image} alt={label} />
                  <span>
                    {label}
                    <br />
                    <span style={{ color: '#67707D', fontSize: 14 }}>{subtitle}</span>
                  </span>
                </Link>
              </li>
            ))}
          </ul>
          <div className="dropdown-button">Desenvolvedores</div>
        </div>
      </S.MenuItem>
      <S.MenuItem className={isActivePage('/boletos')}>
        <div className="dropdown">
          <ul className="dropdown-content">
            {subMenusHelp.map(({ label, image, subtitle, path }) => (
              <li key={path}>
                <Link
                  className="dropdown-item"
                  to={path}
                  onClick={() =>
                    sendSubmenuEvent({
                      cta: 'Suporte',
                      subMenu: label,
                    })
                  }
                >
                  <img src={image} alt={label} />
                  <span>
                    {label}
                    <br />
                    <span style={{ color: '#67707D', fontSize: 14 }}>{subtitle}</span>
                  </span>
                </Link>
              </li>
            ))}
          </ul>
          <div className="dropdown-button">Suporte </div>
        </div>
      </S.MenuItem>
    </S.MenuItems>
  );
};
